import { mediaTransformUrl } from "@/lib/media-url";
import { Skeleton } from "@/components/ui/skeleton";
import type { EntryWithMedia } from "@/features/collections/use-collection-entries";

export function EntryThumbnail({ entry, size = 320 }: { entry: EntryWithMedia; size?: number }) {
  const firstMedia = entry.media?.[0]?.media;
  const url = firstMedia
    ? mediaTransformUrl(firstMedia.exif, { w: size, h: size, fit: "cover" })
    : null;

  return (
    <div className="aspect-square overflow-hidden rounded-lg border border-border bg-muted">
      {url ? (
        // eslint-disable-next-line jsx-a11y/img-redundant-alt
        <img
          src={url}
          alt={entry.title ?? "photo"}
          loading="lazy"
          className="h-full w-full object-cover"
        />
      ) : firstMedia?.ingest_status === "pending" ? (
        <Skeleton className="h-full w-full" />
      ) : (
        <div className="grid h-full place-items-center text-xs text-muted-foreground">
          —
        </div>
      )}
    </div>
  );
}
